<template>
  <l-tela titulo="Entregadores">
    <l-consulta
      :colunas="colunas"
      :registros="registros"
      :totalPaginas="paginas"
      @cliqueLinha="abrirAlteracao"
      @buscarPagina="buscar"
    />
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          fab
          large
          fixed
          bottom
          right
          v-bind="attrs"
          v-on="on"
          @click="abrirCadastro"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Adicionar novo entregador</span>
    </v-tooltip>
  </l-tela>
</template>

<script>
import entregadorService from '@/services/entregador.service'
import LoadingMixin from '@/components/Mixins/Loading'
import NotificacaoMixin from '@/components/Mixins/Notificacao'

export default {
  mixins: [LoadingMixin, NotificacaoMixin],
  data() {
    return {
      colunas: [
        {
          text: 'Nome do entregador',
          align: 'start',
          sortable: false,
          value: 'nome',
          width: 500,
        },
        { text: 'Contato', value: 'contato' },
      ],
      registros: [],
      paginas: 0,
    }
  },
  mounted() {
    this.buscar()
  },
  methods: {
    abrirCadastro() {
      this.$router.push({ name: 'rota-entregador-cadastrar' })
    },
    abrirAlteracao(registro) {
      const { _id } = registro
      if (_id) {
        this.$router.push({
          name: 'rota-entregador-alterar',
          params: { entregadorId: _id },
        })
      }
    },
    async buscar(pagina = 1) {
      this.mostrarLoading()
      try {
        const produtos = await entregadorService.buscaTodos(pagina)
        this.registros = produtos.lista
        this.paginas = produtos.pages
      } catch (error) {
        this.mostraNotificacao(error)
      } finally {
        this.fecharLoading()
      }
    },
  },
}
</script>
